import {Injectable} from '@angular/core';
import {Subject} from 'rxjs/Subject';

import {HttpOptionsModel} from '@myModels/Shared/http-options';
import {CustomHttpService} from '@myServices/custom-http.service';
import {catchError, map} from 'rxjs/operators';
import {BehaviorSubject} from "rxjs/BehaviorSubject";

@Injectable()
export class BrandService {

    public currentBrands = new BehaviorSubject([-1]);

    constructor(private customHttpService: CustomHttpService) {
    }

    getBrandListForSlots() {
        let postData = {
            type: 0
        }
        return this.getBrandList(postData);
    }

    getBrandListForVirtualSports() {
        let postData = {
            groupType: 24
        }
        return this.getBrandList(postData);
    }

    getBrandListForLiveCasino() {
        let postData = {
            type: 2
        }
        return this.getBrandList(postData);
    }

    getBrandList(postData: any) {
        let httpOptions = new HttpOptionsModel('/site-brand-list', postData, false, true);
        return this.customHttpService.post(httpOptions).pipe(
            catchError((error) => {
                if (error.error.messages) {
                    throw new Error(error.error.messages[0]);
                }
                throw new Error('UNEXPECTED_ERROR');
            }), map((res: any) => {
                if (!res.status) {
                    throw new Error(res.messages[0]);
                }
                return res;
            })
        );
    }

    getCurrentBrands() {
        return this.currentBrands.asObservable();
    }

    onCurrentBrandsChange(brands) {
        this.currentBrands.next(brands);
    }

}



// WEBPACK FOOTER //
// C:/Users/beyn/Documents/GitLab/spinmatic-casino/src/app/Modules/Shared/services/brand.service.ts